module.exports = __webpack_public_path__ + "img/mp3-file.55a58b55.png";